import styled from 'styled-components'
import { ListWithImg as ListWithImgOld } from 'Pages/landings/newLandings/common/components'
import {
	themeObject,
	textModels,
	Breakpoints,
	media,
} from 'Pages/landings/newLandings/common/style'

export const Title = styled.p`
	${textModels('heading', 'h2', '600')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
	margin-bottom: 16px;
`
export const ListWithImg = styled(ListWithImgOld)`
	display: flex;
	align-items: center;
	height: initial;
	${media('height: 366px;', Breakpoints.ms)};
	${media('height: 372px;', Breakpoints.lx)};
	${media('height: 376px;', Breakpoints.xl)};
`
export const Text = styled.p`
	${textModels('text', 'l')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
`

export const SubTitle = styled(Text)`
	margin-bottom: 24px;
`
